<template>
<div class="checkout">
    <form @submit.prevent="validateBeforeSubmit">
      <div class="text-xs-left title ma-2">
        Checkout
      </div>
      <v-layout justify-center>
        <v-flex xs12 sm10 md8 lg6>
          <hr />
          <BuyerDetails ref="buyerDetails"></BuyerDetails>
          <hr />
          <AddressDetails ref="addressDetails"></AddressDetails>
          <hr />
          <DeliveryDetails ref="deliveryDetails"></DeliveryDetails>
          <hr />
          <PaymentDetails v-if="stripeReady" ref="paymentDetails"></PaymentDetails>
          <div v-else>
            Loading Payment processor...<v-progress-circular indeterminate></v-progress-circular>
          </div>
          <hr />
          <CommentsForSeller ref="sellerComments"></CommentsForSeller>

          <div class="error--text" v-if="anyInvalid">Please correct errors and re-submit form.</div>
          <div class="error--text" v-if="submissionError">{{ submissionError }}</div>

          <v-btn class="success" :loading=sendingForm :disabled=sendingForm type="submit">Review Order</v-btn>
        </v-flex>
      </v-layout>
    </form>
</div>

</template>

<script>
import {mapState} from 'vuex'
import BuyerDetails from './BuyerDetails.vue'
import DeliveryDetails from './DeliveryDetails.vue'
import AddressDetails from './AddressDetails.vue'

import PaymentDetails from './PaymentDetails.vue'
import CommentsForSeller from './CommentsForSeller.vue'
import utils from '../../../utils.ts'
// import config from '../../config.js'

export default {
  name: 'Checkout',
  components: {
    BuyerDetails,
    DeliveryDetails,
    PaymentDetails,
    CommentsForSeller,
    AddressDetails
  },
  data: function () {
    return {
      anyInvalid: false,
      sendingForm: false,
      submissionError: null
    }
  },
  mounted: function () {
    // Dynamically load recaptcha
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=explicit')
    document.head.appendChild(recaptchaScript)

    // Dynamically load stripeScript if not loaded.
    utils.loadStripe()
  },
  methods: {
    validateBeforeSubmit: function (event) {
      event.preventDefault()

      this.anyInvalid = false
      this.submissionError = false
      const formData = {}

      for (const child in this.$refs) {
        // this.$refs[child].$v.$touch()
        // const invalid = this.$refs[child].$v.$invalid
        const invalid = !this.$refs[child].isValid()
        if (invalid) {
          this.anyInvalid = true
          console.log('Invalid child is: ' + child)
        } else {
          formData[child] = this.$refs[child].getData()
        }
      }

      // Add the cart info
      formData['cartDetails'] = {
        'cartId': this.cartId,
        'artistId': this.$route.params.aid
      }

      if (!this.anyInvalid) {
        // Really submit the form, all looks good!

        this.$store.commit('cart/setStripeToken', null) // Remove any other token
        // We need to get the Stripe Token for Credit Cards
        if (formData['paymentDetails'].type === 'creditcard') { // Payment Type is credit
          let addr = null
          if (this.useDeliveryAddressForBilling) {
            addr = this.deliveryAddress
          } else {
            addr = this.billingAddress
          }

          const tokenData = {
            name: this.name,
            address_line1: addr.street,
            address_city: addr.city,
            address_state: addr.state,
            address_zip: addr.zip5,
            address_country: 'US'
          }
          this.$refs['paymentDetails'].getStripeToken(tokenData).then((result) => {
            if (result.error) {
              // Inform the user if there was an error.
              this.submissionError = result.error.message
            } else {
              // Store the token locally so we can send later
              this.$store.commit('cart/setStripeToken', result.token)
              // formData['stripeToken'] = result.token
              // this._completeFormSubmission(formData)
              this.$router.push({name: 'ReviewOrder'})
            }
          })
        } else {
          // this._completeFormSubmission(formData)
          this.$router.push({name: 'ReviewOrder'})
        }
      }
    }
  },
  computed: {
    ...mapState({
      cartId: state => state.cart.cartId,
      deliveryAddress: state => state.cart.deliveryAddress,
      billingAddress: state => state.cart.billingAddress,
      useDeliveryAddressForBilling: state => state.cart.useDeliveryAddressForBilling,
      name: state => state.buyerInfo.name,
      stripeReady: state => state.shopping.stripeReady
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.checkout {
    width: 100%;
}

</style>
